import { Outlet } from 'react-router-dom';

import Header from '../../components/Header';

import AssistantNav from './AssistantNav';

/**
 * Parent shell for the Assistant tool. Renders the header, the sub-tab
 * strip, and the active child scene via `<Outlet />`. The shell is
 * intentionally thin — every sub-tab is its own scene component so
 * they can evolve independently.
 */
const AssistantScene = () => (
  <div className="bg-bg-primary text-fg-primary flex min-h-screen flex-col">
    <Header />
    <main className="flex flex-1 flex-col gap-4 px-6 py-5">
      <div className="flex flex-col gap-1">
        <h1 className="text-sm font-semibold uppercase tracking-widest">Assistant</h1>
        <p className="text-fg-secondary text-xs">
          Inspect what the assistant has captured for a family and delete noisy or stale memories. Walk a user's session
          history one message at a time, and hard-delete one session or every session on request.
        </p>
      </div>
      <AssistantNav />
      <Outlet />
    </main>
  </div>
);

export default AssistantScene;
